import { useCallback, useState, useLayoutEffect } from 'react';
import { useEventListener } from 'react-haiku';

export const useDimensions = () => {
	const [ref, setRef] = useState(null);
	const [dimensions, setDimensions] = useState({
		y: 0,
		x: 0,
		width: 0,
		height: 0
	});

	const handleSize = useCallback(() => {
		setDimensions(prev => ({
			...prev,
			y: ref?.offsetTop,
			x: ref?.offsetLeft,
			width: ref?.offsetWidth || 0,
			height: ref?.offsetHeight || 0
		}));
		// eslint-disable-next-line
	}, [ref?.offsetWidth, ref?.offsetHeight]);

	useEventListener('resize', handleSize);

	useLayoutEffect(() => {
		handleSize();
		// eslint-disable-next-line
	}, [ref?.offsetWidth, ref?.offsetHeight]);

	return [setRef, dimensions];
};